import { Row } from "./Row";
interface IProsp {
  isShow: boolean;
  onToggle: () => void;
}

export const AmendmentsToThisPolicy = ({ onToggle, isShow }: IProsp) => {
  return (
    <Row title="Amendments to this Policy" onToggle={onToggle} isShow={isShow}>
      <div>
        OUR BUSINESS CHANGES CONSTANTLY, AND OUR PRIVACY POLICY AND THE TERMS OF
        USE WILL CHANGE ALSO. WE MAY EMAIL PERIODIC REMINDERS OF OUR POLICY AND
        TERMS, BUT YOU SHOULD CHECK OUR WEBSITE FREQUENTLY TO SEE RECENT
        CHANGES. UNLESS STATED OTHERWISE, OUR CURRENT PRIVACY POLICY APPLIES TO
        ALL INFORMATION THAT WE HAVE ABOUT YOU AND YOUR ACCOUNT.
        <div className="mt-4">
          We stand behind the promises we make and will never materially change
          our policies and practices to make them materially less protective of
          user information collected in the past without the consent of affected
          users.
        </div>
        <div className="mt-4">
          We may amend this policy from time to time. We will make amendments to
          the policy by displaying an amended copy on our mobile applications,
          website, and social media sites or, if Medcursor determines that it is
          necessary, by sending a notice to you by email. Your continued use of
          a Medcursor mobile application, our website, or a Medcursor social media
          account after a revised version of this policy appears on the mobile
          application, website, or social media account will constitute your
          approval of the amended version.
        </div>
      </div>
    </Row>
  );
};
